export default __webpack_public_path__ + "static/media/showarea.4f143a43.svg";